// The `?next=` return path of the login page. Only same-origin paths are
// accepted, so a crafted login link can't send the user to another site.

export function safeNextPath(value: unknown): string | undefined {
  if (typeof value !== 'string' || !value.startsWith('/')) return undefined
  // `//host` and `/\host` are protocol-relative to the browser; control
  // characters have no business in a path.
  if (value.startsWith('//') || value.startsWith('/\\')) return undefined
  // eslint-disable-next-line no-control-regex
  if (/[\u0000-\u001f\u007f\\]/.test(value)) return undefined
  if (value === '/login' || value.startsWith('/login?')) return undefined
  return value
}
